export const LS_KEY = 'tenant-app';
